import React from 'react'
import { Button, Dropdown, Menu, Spin, Tooltip } from 'antd'
import { EditOutlined, SettingOutlined, EllipsisOutlined } from '@ant-design/icons'
import { ItemType } from 'antd/es/menu/hooks/useItems'
import { t } from '../../../../config/i18n'
import styles from './Actions.module.scss'
import { observer } from 'mobx-react'

export type TExtraAction = [string, () => void]

export interface TableActionsProps {
  loading?: boolean
  onEdit?: () => void
  onSettings?: () => void
  onDelete?: () => void
  extra?: TExtraAction[]
}

export const TableActions = observer(({ loading, onEdit, onSettings, onDelete, extra }: TableActionsProps) => {
  const [modalForCatalogId, setModalForCatalogId] = React.useState('')

  if (loading) {
    return (
      <div className={styles.root}>
        <Spin />
      </div>
    )
  }

  const menuItems: (ItemType & { onClick?: () => void })[] = (extra || []).map(([label, cb]) => ({
    label,
    key: label,
    onClick: cb,
  }))

  if (onDelete) {
    menuItems.push({ key: 'delete', label: t.tableActions.delete, onClick: onDelete })
  }

  return (
    <div className={styles.root}>
      {onEdit && (
        <Tooltip placement={'bottom'} title={t.tableActions.edit}>
          <Button icon={<EditOutlined />} onClick={onEdit} />
        </Tooltip>
      )}
      {onSettings && (
        <Tooltip placement={'bottom'} title={t.tableActions.settings}>
          <Button icon={<SettingOutlined />} onClick={onSettings} />
        </Tooltip>
      )}
      {menuItems.length > 0 && (
        <Dropdown overlay={<Menu items={menuItems} />} trigger={['click']}>
          <Button icon={<EllipsisOutlined />} />
        </Dropdown>
      )}
    </div>
  )
})
